// src/components/layout/Sidebar.tsx
import React from 'react';
import * as S from './Sidebar.styles';
import { menuItems } from './sidebar.data';
import MenuItem from './MenuItem';
import { canAccessReportes } from '../../helpers/session';

const Sidebar: React.FC<{ isSidebarOpen: boolean }> = ({ isSidebarOpen }) => {
  const items = menuItems.filter((item) =>
    item.path === '/reportes' ? canAccessReportes() : true,
  );

  return (
    <S.SidebarContainer isOpen={isSidebarOpen}>
      <S.LogoContainer isOpen={isSidebarOpen}>
        <S.LogoText isOpen={isSidebarOpen}>Etiquetado envases</S.LogoText>
        <S.LogoInitials isOpen={isSidebarOpen}>EV</S.LogoInitials>
      </S.LogoContainer>
      <S.NavList>
        {items.map((item) => (
          <MenuItem key={item.path} item={item} isSidebarOpen={isSidebarOpen} />
        ))}
      </S.NavList>
    </S.SidebarContainer>
  );
};

export default Sidebar;
